export default "__VITE_ASSET__B8Z8ydc2__"